import React from "react";
import { SCORING_CRITERIA } from "@/lib/constants";
import { Input } from "@/components/ui/input";
import { Info, LinkIcon } from "lucide-react";

// Displays 12-criterion grid. Each item: name, weight, 1-10 input, optional source url for auto-defaultable ones.
export default function ScoringGrid({ lead, onFieldChange, disabled }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      {SCORING_CRITERIA.map((c) => {
        const value = lead[c.key];
        const isAutoDefaultable = ["import_dependency_score", "logistics_ease_score", "market_growth_score"].includes(c.key);
        const srcKey = c.key.replace("_score", "_source");
        const sourceVal = lead[srcKey];
        const isAutoDefault = sourceVal === "auto-default";
        const isOverride = sourceVal === "manual override";
        const isTracked = c.weight === 0;

        return (
          <div key={c.key}
               className={`p-4 rounded-md border relative overflow-hidden transition-colors ${
                 isTracked ? "bg-slate-50 border-slate-200"
                 : value != null ? "bg-white border-slate-200"
                 : "bg-slate-50/50 border-dashed border-slate-300"
               }`}
               data-testid={`score-${c.key}`}>
            <div className="flex items-start justify-between gap-2">
              <div className="flex-1">
                <div className="text-[10px] uppercase tracking-wider font-semibold text-slate-500">
                  Weight {c.weight}%
                </div>
                <div className="font-medium text-slate-900 text-sm mt-1 leading-snug">{c.label}</div>
              </div>
              {isAutoDefault && (
                <span className="text-[10px] uppercase font-semibold text-amber-700 bg-amber-100 border border-amber-200 rounded px-1.5 py-0.5 whitespace-nowrap">Auto</span>
              )}
              {isOverride && (
                <span className="text-[10px] uppercase font-semibold text-slate-700 bg-slate-100 border border-slate-300 rounded px-1.5 py-0.5 whitespace-nowrap">Manual</span>
              )}
            </div>

            <div className="mt-3 flex items-center gap-2">
              <Input
                type="number"
                min={1}
                max={10}
                value={value ?? ""}
                onChange={(e) => {
                  const v = e.target.value === "" ? null : Math.min(10, Math.max(1, parseInt(e.target.value, 10) || 1));
                  onFieldChange(c.key, v);
                }}
                disabled={disabled}
                data-testid={`score-input-${c.key}`}
                className="w-20 h-10 text-center font-mono text-lg font-semibold"
                placeholder="—"
              />
              <div className="text-xs text-slate-500 flex-1 leading-tight">{c.help}</div>
            </div>

            {c.weight > 0 && value != null && (
              <div className="mt-3">
                <div className="h-1 bg-slate-100 rounded-full overflow-hidden">
                  <div
                    className={`h-full ${value >= 7 ? "bg-amber-600" : value >= 4 ? "bg-slate-500" : "bg-slate-300"}`}
                    style={{ width: `${(value / 10) * 100}%` }}
                  ></div>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
